/** Integração com o Autonomous (fases 3 e 5): domínios da API (com o estado das integrações, só leitura), aprovação em nome da pessoa e referência externa. */
const en = {
  'scope.deployments': 'Deployments (follow; in read and send, create — a person still approves)',
  'scope.approvals': 'Approvals on behalf of a person (Autonomous)',
  'scope.integrations': 'State of the integrations (read only; never their secrets)',
  'api.onBehalf': 'Approves on behalf of people',
  'api.onBehalfHint': 'Sends the decision of a Hive user in X-Hive-On-Behalf-Of; it never approves on its own.',
  'dp.d.requestedFor': 'Requested through the API on behalf of {who}',
  'dp.d.externalRef': 'External reference: {ref}',
};

const ptBR: Record<keyof typeof en, string> = {
  'scope.deployments': 'Implantações (acompanhar; em leitura e envio, criar — a aprovação continua sendo de uma pessoa)',
  'scope.approvals': 'Aprovações em nome da pessoa (Autonomous)',
  'scope.integrations': 'Estado das integrações (só leitura; nunca os segredos delas)',
  'api.onBehalf': 'Aprova em nome de pessoas',
  'api.onBehalfHint': 'Envia a decisão de um usuário do Hive em X-Hive-On-Behalf-Of; nunca aprova sozinha.',
  'dp.d.requestedFor': 'Pedida pela API em nome de {who}',
  'dp.d.externalRef': 'Referência externa: {ref}',
};

const es: Record<keyof typeof en, string> = {
  'scope.deployments': 'Implementaciones (seguir; en lectura y envío, crear — la aprobación sigue siendo de una persona)',
  'scope.approvals': 'Aprobaciones en nombre de la persona (Autonomous)',
  'scope.integrations': 'Estado de las integraciones (solo lectura; nunca sus secretos)',
  'api.onBehalf': 'Aprueba en nombre de personas',
  'api.onBehalfHint': 'Envía la decisión de un usuario de Hive en X-Hive-On-Behalf-Of; nunca aprueba sola.',
  'dp.d.requestedFor': 'Pedida por la API en nombre de {who}',
  'dp.d.externalRef': 'Referencia externa: {ref}',
};

export const autonomousApiMessages = { en, 'pt-BR': ptBR, es } as const;
